export default __webpack_public_path__ + "static/media/background-03.6700fe48.webp";